function iWishCounter() {
	       	try{
	         if (typeof iWish !== 'undefined' ){
	            if(iWish.getCounter() <= 0){
	              document.querySelectorAll(".iw-count-show").forEach((elm) => {
	                elm.style.display = 'none';
	              })
	            }
	            else{
	              document.querySelectorAll(".iw-count-show").forEach((elm) => {
	                elm.style.display = 'flex';
	              })
	            }
	          }
	       }
	       catch(error){
	         //console.log(error);
	       }
	    }

		function iWishRemoveFn(vId){
			try{
			iWishCounter();
			}
			catch(error){
			//console.log(error);
			}
		}
		function iWishAddFn(vId){
			try{
			iWishCounter();
			}
			catch(error){
			//console.log(error);
			}
		}
		function iWishinitFn(){
			try{
			    iWishCounter();
                iWishData.money_format = "¥{{amount_no_decimals}}" +" " + Shopify.currency.active;
			}
			catch(error){
			    //console.log(error);
			}
		}
        function iw_cart_update(){
			try{
				const currentCart = document.querySelector('cart-drawer');
				fetch('/cart.js')
				.then((response) => response.json())
				.then((data) => {
					if (currentCart && currentCart.classList.contains('is-empty')) currentCart.classList.remove('is-empty');
					if( document.querySelectorAll( ".cart-count-bubble" ).length == 0) {
						console.log("len 0");
						document.querySelector( ".header__icon--cart" ).innerHTML = `<svg class="icon icon-cart" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path></svg><div class="cart-count-bubble"><span aria-hidden="true">${data.item_count}</span></div>`;
					}
				})
			}
			catch(error){
				console.log("error: ",error);
			}
        }
        function addToCartInitCallback(){
            iw_cart_update();
        }
        function addAllToCartInitCallback(){
            iw_cart_update();
        }